"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var GameConstants_1 = require("./GameConstants");
var GameVars_1 = require("./GameVars");
var BoardManager_1 = require("./board/BoardManager");
var BoardState_1 = require("./board/BoardState");
var SplashState_1 = require("./splash/SplashState");
var ConnectionManager = /** @class */ (function () {
    function ConnectionManager() {
    }
    ConnectionManager.init = function (game) {
        return __awaiter(this, void 0, void 0, function () {
            var io, gzpContext, _a, _b;
            var _this = this;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        GameVars_1.GameVars.initialID = null;
                        GameVars_1.GameVars.needsStart = true;
                        if (!this.hasEventsRegistered) {
                            // console.warn("Registering events");
                            window.addEventListener("offline", function () {
                                console.log("offline");
                                /*  if (process.env.NODE_ENV === "development") {
                                     ConnectionManager.socket.disconnect();
                                 } */
                            });
                            window.addEventListener("online", function () {
                                console.log("online");
                                /*  if (process.env.NODE_ENV === "development") {
                                     ConnectionManager.socket.connect();
                                 } */
                            });
                            window.addEventListener("beforeunload", function () {
                                ConnectionManager.socket.emit("end_game", { id: GameVars_1.GameVars.initialID, leave: -1 });
                                ConnectionManager.socket.disconnect();
                            });
                            window.addEventListener("unload", function () {
                                ConnectionManager.socket.emit("end_game", { id: GameVars_1.GameVars.initialID, leave: -1 });
                                ConnectionManager.socket.disconnect();
                            });
                            this.hasEventsRegistered = true;
                        }
                        ConnectionManager.game = game;
                        io = require("socket.io-client");
                        gzpContext = gamezop.context;
                        this.manageGameMode();
                        console.log(this.contestId);
                        if (!(process.env.NODE_ENV === "development")) return [3 /*break*/, 2];
                        // http://localhost:5000
                        // "http://192.168.1.2:5024"
                        // "wss://dev-genserver.gamezop.com"
                        _a = ConnectionManager;
                        return [4 /*yield*/, io.connect("wss://dev-genserver.gamezop.com", {
                                query: "context=" + gzpContext + "&mode=" + GameVars_1.GameVars.gzpGameMode + "&contestId=" + this.contestId + "\n              &gzpId=" + this.gzpId
                            })];
                    case 1:
                        // http://localhost:5000
                        // "http://192.168.1.2:5024"
                        // "wss://dev-genserver.gamezop.com"
                        _a.socket = _c.sent();
                        return [3 /*break*/, 4];
                    case 2:
                        _b = ConnectionManager;
                        return [4 /*yield*/, io.connect("wss://solitaire.gamezop.com", {
                                query: "context=" + gzpContext + "&mode=" + GameVars_1.GameVars.gzpGameMode + "&contestId=" + this.contestId + "\n            &gzpId=" + this.gzpId
                            })];
                    case 3:
                        _b.socket = _c.sent();
                        _c.label = 4;
                    case 4:
                        // attach event handlers
                        ConnectionManager.socket.on("connect", function () {
                            console.warn("on connect!!");
                            // console.log("connect fired!");
                            if (!GameVars_1.GameVars.initialID) {
                                GameVars_1.GameVars.initialID = ConnectionManager.socket.id;
                            }
                            ConnectionManager.socket.emit("set_data", GameVars_1.GameVars.initialID);
                        });
                        ConnectionManager.socket.on("disconnect", function () {
                            console.log("disconnect fired!");
                            if (GameVars_1.GameVars.gameEnded === GameConstants_1.GameConstants.NO_FINAL) {
                                BoardManager_1.BoardManager.currentInstance.showWaitingServer();
                            }
                        });
                        ConnectionManager.socket.on("reconnect", function () {
                            console.log("reconnect fired!");
                        });
                        ConnectionManager.socket.on("set_data", function () {
                            // console.log("Set data called!!");
                            // console.log("GameVars.needsStart", GameVars.needsStart);
                            if (GameVars_1.GameVars.needsStart) {
                                GameVars_1.GameVars.needsStart = false;
                                BoardState_1.BoardState.currentInstance.startGame();
                            }
                            else {
                                BoardManager_1.BoardManager.currentInstance.hideWaitingServer();
                            }
                        });
                        ConnectionManager.socket.on("timer", function (data) {
                            GameVars_1.GameVars.time = data.time;
                            // console.log("timer", data.time);
                            if (data.time === 0) {
                                GameVars_1.GameVars.gameEnded = GameConstants_1.GameConstants.FINAL_TIME;
                                BoardManager_1.BoardManager.currentInstance.showWinner(GameConstants_1.GameConstants.FINAL_TIME);
                            }
                        });
                        ConnectionManager.socket.on("initial_deck", function (data) {
                            // console.log("initial_deck", data);  
                            BoardManager_1.BoardManager.currentInstance.initialCards(data);
                        });
                        ConnectionManager.socket.on("server_cards", function (data) {
                            // console.log("server_cards", data);
                            GameVars_1.GameVars.points = data.score;
                            GameVars_1.GameVars.moves = data.moves;
                            if (JSON.stringify(data.pilesData) === JSON.stringify(GameVars_1.GameVars.pilesData)) {
                                BoardManager_1.BoardManager.currentInstance.hideWaitingServer();
                            }
                            else {
                                console.log("CARDS VALUES ARE DIFFERENT FROM SERVER");
                                GameVars_1.GameVars.pilesData = data.pilesData;
                                BoardManager_1.BoardManager.currentInstance.putCardsFromServer();
                                BoardManager_1.BoardManager.currentInstance.hideWaitingServer();
                            }
                            BoardManager_1.BoardManager.currentInstance.checks(!data.autocomplete);
                            BoardState_1.BoardState.currentInstance.hud.updatePoints();
                            BoardState_1.BoardState.currentInstance.hud.updateMoves();
                            if (data.autocomplete && GameVars_1.GameVars.gameEnded === GameConstants_1.GameConstants.NO_FINAL) {
                                setTimeout(function () {
                                    BoardManager_1.BoardManager.currentInstance.autoCompleteGame();
                                }, 200);
                            }
                        });
                        ConnectionManager.socket.on("inactive", function (data) {
                            if (_this.isBattle && _this.isGameEnd) {
                                return;
                            }
                            console.log("abrupt end, due to inactivity");
                            GameVars_1.GameVars.gameEnded = GameConstants_1.GameConstants.ABRUPT_END;
                            BoardManager_1.BoardManager.currentInstance.showWinner(GameConstants_1.GameConstants.ABRUPT_END);
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    /*
      {
        matchId: Jojo,
        gameConfig: 10
      }
    */
    ConnectionManager.setPropertiesOnGameInit = function (matchData) {
        if (matchData && matchData.matchId) {
            oMetaManager.sync();
            console.log("🚀matchData", matchData);
            ConnectionManager.contestId = matchData.matchId;
            ConnectionManager.gameConfig = matchData.gameConfig;
            console.warn("Calling gameInit");
            ConnectionManager.isGameEnd = false;
            for (var i = 0; i < matchData.players.length; i++) {
                if (matchData.players[i].isClient) {
                    this.gzpId = matchData.players[i].gzpId;
                }
            }
            ++ConnectionManager.battleCount;
            if (ConnectionManager.battleCount > 1) {
                BoardState_1.BoardState.currentInstance.game.state.start("BoardState", true, false);
            }
            else {
                SplashState_1.SplashState.currentInstance.game.state.start("BoardState", true, false);
            }
        }
        else {
            console.warn("No match found");
        }
    };
    ConnectionManager.onGameEnd = function () {
        if (!this.isGameEnd) {
            console.warn("on Abrupt end");
            GameVars_1.GameVars.gameEnded = GameConstants_1.GameConstants.ABRUPT_END;
            BoardManager_1.BoardManager.currentInstance.showWinner(GameConstants_1.GameConstants.ABRUPT_END);
        }
    };
    ConnectionManager.setGzpId = function () {
        return __awaiter(this, void 0, void 0, function () {
            var sdkData, e_1, rndCode;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, gamezop.isLoggedIn()];
                    case 1:
                        sdkData = _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        e_1 = _a.sent();
                        console.log("Error occured due to", e_1);
                        return [3 /*break*/, 3];
                    case 3:
                        if (sdkData && sdkData.userData) {
                            this.gzpId = sdkData.userData.gzpId;
                        }
                        else {
                            rndCode = Math.random().toFixed(5).split(".")[1];
                            this.gzpId = "gzp_anon_" + rndCode;
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    ConnectionManager.manageGameMode = function () {
        var contestData = gamezop.getContestDetails();
        if (contestData && contestData.contestId) {
            GameVars_1.GameVars.gzpGameMode = "tournament";
            this.contestId = contestData.contestId;
        }
        else if (this.isBattle) {
            GameVars_1.GameVars.gzpGameMode = "battle";
        }
        else {
            this.contestId = "casual";
            GameVars_1.GameVars.gzpGameMode = "casual";
        }
        return GameVars_1.GameVars.gzpGameMode;
    };
    ConnectionManager.isBattle = false;
    ConnectionManager.isGameEnd = false;
    ConnectionManager.hasEventsRegistered = false;
    ConnectionManager.battleCount = 0;
    return ConnectionManager;
}());
exports.ConnectionManager = ConnectionManager;
